import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../main/components/RopChart";
import { EmptyTable } from "../../clients/components/EmptyState";
import { MTTRMTBFValues } from "../../usinas/types";
import { formatTimeSpanToString } from "../../../main/utils/utils";

export function convertTimeSpanToMinutes(time: string): number {
  const [hora, minuto, segundo] = time.split(":");

  if (hora !== "00") {
    return Number(`${Number(hora) * 60 + Number(minuto)}.${segundo}`);
  }
  return Number(`${minuto}.${segundo}`);
}

export default function MTTRAndMTBFChart(props: {
  data: {
    name: string;
    usinaId: number;
    values: MTTRMTBFValues;
  }[];
  ugName: string;
  isMTTR: boolean;
}) {
  const { data, ugName, isMTTR } = props;

  const xAxisData = data.map((inversor) => inversor.name);

  const inversorData = data.map((inversor) =>
    isMTTR
      ? convertTimeSpanToMinutes(inversor.values.tempoMedioReparo)
      : convertTimeSpanToMinutes(inversor.values.tempoMedioEntreFalhas)
  );
  const options: EChartsOption = {
    backgroundColor: "transparent",
    title: {
      text: `${isMTTR ? "MTTR" : "MTBF"} - ${ugName}`,
    },
    grid: {
      top: 90,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        rotate: 65,
      },
      axisPointer: {
        type: "shadow",
      },
    },
    yAxis: {
      type: "value",
      name: "Tempo",
      axisLabel: {
        formatter: function (value) {
          return formatTimeSpanToString(Number(value), true);
        },
      },
    },
    series: [
      {
        name: isMTTR ? "MTTR" : "MTBF",
        type: "bar",
        label: {
          show: true,
          position: "top",
          formatter: function (params) {
            const inversor = data.find((inv) => params.name === inv.name);
            return inversor
              ? inversor.values.quantidadeDeFalhas.toString()
              : "";
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return formatTimeSpanToString(Number(value));
          },
        },
        data: inversorData,
        itemStyle: {
          color: "#EE7D00",
        },
      },
    ],
  };

  const hasData = data.length > 0;

  return (
    <>
      {hasData ? (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "90%",
            width: "100%",
          }}
        >
          <RopChart option={options} />
        </Container>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyTable title={`${isMTTR ? "MTTR -" : "MTBF -"} Não houve falha detectada no período`} />
        </Box>
      )}
    </>
  );
}
